import React from 'react';

import logo from '../The_Pool_of_London_by_John_Wilson_Carmichael.jpg';

function Home() {
    return (
        <div className="card card-clean">
            <div className="card-header text-white p-0 overlay">
                <img className="card-img-top" src={logo} alt="logo" />
            </div>
            <div className="card-body">
                <h5>Registrations are now closed</h5>
            </div>
        </div>
    );
}
export default Home;
